import { loadable } from "components/SpruceLoader";

export const VersionTiming = loadable(() => import("./VersionTiming/index"));
